import React from 'react';
import { FaArrowLeft } from "react-icons/fa6";

interface PromotionHeaderProps {
  icon: React.ReactNode;
  name: string;
}

const PromotionHeader: React.FC<PromotionHeaderProps> = ({ icon, name }) => {
  return (
    <div className="flex gap-4 w-screen pt-3 pb-2 bg-black text-white">
      <div className="flex items-center justify-start w-1/3 pl-5 text-xl">
        {icon}
      </div>
      <div className="flex justify-center w-2/3 text-xl font-normal">
        {name}
      </div>
      <div className="w-1/3"></div>
    </div>
  );
};

export default PromotionHeader;
